import axios from 'axios'
// import { socketService } from '../../../services/socket'

const apiUrl = `https://api.careerroshi.com`
// const apiUrl = `http://localhost:4000`

export const AddActivities = async (body) => {
    try {
        let url = await axios.post(`${apiUrl}/addActivites/`, body)
        return url.data
    } catch (error) {
        console.log(error)
        return ''
    }
}

export const GetActivities = async (data) => {
    try {
        let url = await axios.get(`${apiUrl}/activities`, { params: data })
        return url.data
    } catch (error) {
        console.log(error)
        return []
    }
}

export const DeleteActivity = async (id) => {
    try {
        let url = await axios.put(`${apiUrl}/delete-activity/${id}`)
        return url.data
    } catch (error) {
        console.log(error)
        return []
    }
}

export const AddFile = async (body) => {
    try {
        let url = await axios.post(`${apiUrl}/addFile/`, body)
        return url.data
    } catch (error) {
        console.log(error)
        return ''
    }
}

export const GetFile = async (data) => {
    try {
        let url = await axios.get(`${apiUrl}/files`, { params: data })
        return url.data
    } catch (error) {
        console.log(error)
        return []
    }
}

export const DeleteFile = async (id) => {
    try {
        let url = await axios.put(`${apiUrl}/delete-files/${id}`)
        return url.data
    } catch (error) {
        console.log(error)
        return []
    }
}

export const UpdateFileAction = async (id, body) => {
    try {
        let url = await axios.put(`${apiUrl}/edit-file/${id}`, body)
        return url.data
    } catch (error) {
        console.log(error)
        return []
    }
}

export const UpdateUserAction = async (id, body) => {
    try {
        let url = await axios.put(`${apiUrl}/update-user/${id}`, body)
        return url.data
    } catch (error) {
        console.log(error)
        return []
    }
}

export const FetchCoachStats = async (id) => {
    try {
        let url = await axios.get(`${apiUrl}/coach-stats/${id}`)
        return url.data
    } catch (error) {
        console.log(error)
        return []
    }
}

export const fetchCoachClients = async (id, page, limit) => {
    try {
        let res = await axios.get(`${apiUrl}/user/fetch-coach-client/${id}`, { params: { page, limit } })
        return {users: res.data.users, count: res.data.count}
    } catch (error) {
        console.log(error)
        return {users: [], count: 0}
    }

}